import { CurrencyPipe } from '@angular/common';
import { formatTypes } from '@zipari/shared-ds-util-format';
import { BarGraphData } from './bar-graph/bar-graph.model';
import {
  defaultLength,
  increaseGraphWidthBy,
  reduceBy,
} from './horizontal-bar-graph.constants';

export const getChartWidth = (barGraphData: BarGraphData, barGraphConfig) => {
  let barValue: string;
  let reduceLengthBy: number;

  if (barGraphConfig.formatType === formatTypes.CURRENCY) {
    barValue = new CurrencyPipe('en-US')
      .transform(barGraphData.value)
      .replace(/$|,/g, '');
    reduceLengthBy = reduceBy;
  } else {
    reduceLengthBy = defaultLength;
  }

  const roundOffTo = Number(
    increaseGraphWidthBy
      .toString()
      .padEnd(barValue.length - reduceLengthBy, '0'),
  );
  const barGraphValue = barGraphData.value === 0 ? 1 : barGraphData.value;

  return Math.round((barGraphValue + roundOffTo) / roundOffTo) * roundOffTo;
};
